export * from './get-terminal-defects'
